import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a593aaa2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./nutrition-step-two.scss?vue&type=style&index=0&id=a593aaa2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a593aaa2",
  null
  
)

export default component.exports